import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileDropDownStyle.css';
import { useEffect } from 'react';
import { useRef } from 'react';
function ProfileDropDown({  isActive, setIsActive }) {

    const navigate = useNavigate();
    const ref = useRef();

    const role = localStorage.getItem("role");

    useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsActive(false);
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);

    return (
        <div className={`ProfileDropdownWrapper popupactivebtn ${isActive && "active"}`} ref={ref}>
            <ul className='ListProfileDropdown'>
                <li className='Border-btm pb-12' onClick={() => navigate(`/${role === "4419ab4b-bae0-4426-a4d0-1d2e5f3b60d1" ? 'admin' : role === "69b40b2c-feeb-4ab5-afe2-87694b8f61cf" ? 'mentor' : "mentee"}/my-profile`)} >My Profile</li>
                {/* <li>Guidelines</li>
                <li>Policies</li> */}
                {/* <li className='Border-btm pb-12' onClick={() => navigate(`'/admin/EditProfile'`)}>Settings</li> */}
                <li className='logOut' onClick={() => {localStorage.clear();window.location.reload()}}>Log Out</li>
            </ul>
        </div>
    )
}

export default ProfileDropDown